module.exports = __webpack_public_path__ + "img/ic_share_ig.91c723ff.svg";